import { writable } from 'svelte/store';
import { auth } from '$lib/firebase';
import { IS_AQUEDUCT } from '$lib/site';
import { setTelemetryUser } from '$lib/sentryConsole';
import type { User } from 'firebase/auth';

const authStore = writable<{
	user?: User | null;
	isLoggedIn?: boolean;
	firebaseControlled: boolean;
}>({
	user: undefined, // undefined means we haven't determined their sign-in status yet
	isLoggedIn: undefined,
	firebaseControlled: false
});

authStore.subscribe(({ user }: { user?: User | null }): void => {
	setTelemetryUser(user ? { id: user.uid, ...(user.email ? { email: user.email } : {}) } : null);
});

auth.onIdTokenChanged((user: User | null) => {
	if (IS_AQUEDUCT && typeof document !== 'undefined') {
		const signedIn: string = user ? '1' : '0';
		document.documentElement.dataset.aqueductSignedIn = signedIn;
		try {
			localStorage.setItem('aqueduct:signed-in', signedIn);
		} catch {
			// Storage can be blocked. Still apply the authoritative state to this page.
		}
	}

	authStore.set({
		user: user,
		isLoggedIn: !!user,
		firebaseControlled: true
	});
});

setInterval(
	() => {
		// refresh token every 10 minutes
		auth.currentUser?.getIdToken(true);
	},
	10 * 60 * 1000
);

// A hidden tab's timers can be suspended long enough for the token to expire
// unnoticed. Refreshing on reveal (a no-op while the token is valid) rotates
// every consumer's copy before the user's first action.
if (typeof document !== 'undefined') {
	document.addEventListener('visibilitychange', () => {
		if (document.visibilityState === 'visible') void auth.currentUser?.getIdToken();
	});
}

export default {
	subscribe: authStore.subscribe,
	set: authStore.set
};
